const json = `
<p>广州钱柜物联科技有限公司（如下简称“钱柜”）在此特别提醒用户认真阅读、充分理解本《ix Cam云存储自动续费服务协议》（下称“本协议”）。 用户应认真阅读、充分理解本协议中各条款，特别涉及免除或者限制钱柜责任、争议解决和法律适用的条款。免除或者限制责任的条款将以粗体标识，用户需要重点阅读。请用户审慎阅读并选择接受或不接受本协议（未成年人应在法定监护人陪同下阅读）。 用户开通云存储自动续费服务（下称“本服务”）的行为将视为对本协议的接受，并同意接受本协议各项条款的约束。如用户不同意本协议，请勿开通ix Cam云存储自动续费服务。钱柜有权修订本协议，更新后的协议条款将公布于ix Cam云存储服务官网，自修订协议声明的生效之日起生效。</p>
<p class="subTitle">1、总则</p>
<p>1.1 本服务是在用户已开通云存储VIP会员服务的前提下，为用户提供的自动续费服务。</p>
<p>1.2 本服务的种类、服务标准及计费标准等以ix CamAPP云存储界面及购买具体服务时的页面说明为准，本协议或双方另有约定除外。</p>
<p>1.3 本协议是用户与钱柜及其关联公司以及运营合作单位（如下简称“合作单位”）之间关于用户使用本服务所订立的协议。</p>
<p class="subTitle">2、服务说明</p>
<p>2.1 本服务是出于用户对于自动续费的需求，在用户已开通云存储服务的前提下，避免用户因疏忽或其他原因导致未能及时续费造成损失而推出的服务，用户授权钱柜可在服务有效期即将过期时，委托支付渠道从用户的自有充值帐户、与用户帐号绑定的第三方支付帐户（以下统称“帐户”）余额中代扣下一个计费周期的费用，计费周期包括但不限于月度等（下同），用户可根据ix Cam云存储平台上显示的计费周期自行选择。该服务实现的前提是用户已将其钱柜帐号与上述帐户绑定，且可成功从其上述帐户中扣款。</p>
<p>2.2 自动续费具体指，基于2.1的前提，钱柜通过上述帐户收取用户下一计费周期费用的扣费方式，用户需保证钱柜可以从上述帐户扣款成功，因上述帐户中可扣款余额不足导致的续费失败，由用户自行承担责任，钱柜有权中断或终止相应的用户权益和服务。</p>
<p>2.3 用户选择开通自动续费，则视为同意授权钱柜向帐户发出扣款指令，并同意帐户可以根据钱柜发出的扣款指令，在不验证会员帐户密码、支付密码、短信校验码等信息的情况下从帐户中扣划下一个计费周期的费用。</p>
<p>2.4 用户在享受本服务时，应受《ix Cam云存储用户协议》各项条款及相关子协议、页面说明或规范流程等全部内容的约束，当用户使用本服务时，用户的使用行为视为其对本服务的服务条款以及钱柜针对本服务发出的各类公示的同意。本协议如与《ix Cam云存储用户协议》发生冲突的，以本协议为准。</p>
<p>2.5 钱柜向用户提供的本服务均仅限于云存储平台使用，任何以恶意破解等非法手段将钱柜提供的本服务与本平台分离的行为，均不属于本协议中约定的服务。由此引起的一切法律后果由行为人负责，钱柜将依法追究行为人的法律责任。</p>
<p class="subTitle">3、服务的开通</p>
<p>3.1 如用户开通本服务，则视为用户授权钱柜有权在当前扣费周期服务即将到期时，从用户的签约帐户余额中代扣下一个计费周期服务费，计费周期包括但不限于月度、季度、年度等。</p>
<p>3.2 对于所选择的支付渠道，用户有义务确保定期关注并确保其于该支付方式的帐号项下有充足的余额用于满足本服务的应用。如因前述原因瑕疵（包括但不限于：余额不足、余额不足以满足用户选择多个自动续费服务）而致使无法满足自动续费服务的应用，则钱柜有权暂停用户的云存储服务。</p>
<p>3.3 单个自动续费订单仅对应一个摄像机设备和钱柜帐号，若更换钱柜帐号，需取消旧帐号订阅并重新开通。</p>
<p class="subTitle">4、服务的有效期</p>
<p>4.1 本协议自用户选择接受或使用本服务后生效，直至用户终止本服务。</p>
<p>4.2 用户有权随时在钱柜帐号设置中选择终止本服务，终止本服务后，钱柜将停止向用户提供本服务。</p>
<p>4.3 钱柜有权根据自身业务调整、价格变动等原因中止、终止本服务。一旦发生此种情形，钱柜会以公告的方式通知用户。</p>
<p class="subTitle">5、服务的退订及终止</p>
<p>5.1 用户可自主选择退订本服务。</p>
<p>5.2 解约流程，即关闭自动续费会员服务步骤：</p>
<p>5.2.1用户在相应的开通渠道取消自动续费即可；</p>
<p>5.2.2用户在退订本业务时需确保开通渠道登录的扣费帐户与签约扣费的帐户相同，方可成功退订；</p>
<p>5.2.3 温馨提示：自动续费套餐取消成功后，不影响用户当期已生效的云存储服务权益，权益到期后将不再续费；</p>
<p>5.2.4 用户在选择终止本服务前已经委托钱柜自动续费扣款的指令仍然有效，钱柜对于基于该指令扣除的费用不予退还。</p>
<p class="subTitle">6、争议解决和法律适用</p>
<p>钱柜与用户应通过友好协商解决本协议履行过程中产生的争议，经协商无法解决的，任何一方均有权将争议提交至被告方所在地人民法院诉讼解决。本协议的解释、效力和执行等均适用中华人民共和国法律。</p>
<p class="subTitle">7、其他</p>
<p>本协议更新时间：2025年8月2日</p>
`

export default json
